import { localeFlags } from "./LanguageSwitcher.constants";
import type { LocaleFlagProps } from "./LanguageSwitcher.types";

export const LocaleFlag = ({ locale, className }: LocaleFlagProps) => (
  <span
    className={
      className ??
      "inline-block shrink-0 text-base leading-none [font-family:'Apple_Color_Emoji','Segoe_UI_Emoji','Noto_Color_Emoji',sans-serif]"
    }
    aria-hidden
  >
    {localeFlags[locale]}
  </span>
);
